import { useState } from "react";
import { ChevronDown, Layers, Plus, Trash2 } from "lucide-react";

const CATS = ["Vopsea", "Decolorare", "Oxidanți și activatori", "Îngrijire lungimi", "Îngrijire scalp", "Styling", "Tratamente tehnice", "Bărbați", "Corp și față", "Altele"];

const Gama = ({ g, prods, gamas, setG, move, onDel, fixed = false }) => {
  const [open, setOpen] = useState(fixed);
  return (
    <li className="bf-ge-row" data-testid={`bf-ge-${g.id || "none"}`}>
      {fixed ? <b>Fără gamă ({prods.length}): alege gama pentru fiecare produs</b> : (
        <div className="bf-ge-fields">
          <input value={g.name} onChange={(e) => setG({ ...g, name: e.target.value })} maxLength={60} data-testid={`bf-ge-name-${g.id}`} />
          <select value={g.cat} onChange={(e) => setG({ ...g, cat: e.target.value })} data-testid={`bf-ge-cat-${g.id}`}>{CATS.map((c) => <option key={c}>{c}</option>)}</select>
          <input value={g.desc} onChange={(e) => setG({ ...g, desc: e.target.value })} maxLength={160} placeholder="Pentru ce e gama, pe scurt" className="is-wide" data-testid={`bf-ge-desc-${g.id}`} />
          <select className="is-wide" value={g.img || ""} onChange={(e) => setG({ ...g, img: e.target.value })} data-testid={`bf-ge-img-${g.id}`}>
            <option value="">Poză: automat (primul produs cu poză)</option>
            {prods.filter((p, i, l) => p.image && l.findIndex((x) => x.image === p.image) === i).map((p) => <option key={p.id} value={p.image}>Poză: {p.name.slice(0, 70)}</option>)}
          </select>
        </div>
      )}
      {!fixed && <div className="bf-ge-tools">
        <button type="button" className="bf-gate-switch" onClick={() => setOpen(!open)} data-testid={`bf-ge-open-${g.id}`}>{prods.length} {prods.length === 1 ? "produs" : "produse"} <ChevronDown size={13} /></button>
        <button type="button" className="bf-gate-switch" onClick={onDel} data-testid={`bf-ge-del-${g.id}`}><Trash2 size={13} /> Șterge gama</button>
      </div>}
      {open && <ul className="bf-ge-prods">{prods.map((p) => (
        <li key={p.id}><span>{p.name}</span>
          <select value={g.id} onChange={(e) => move(p, e.target.value)} data-testid={`bf-ge-move-${p.id}`}>{gamas.map((x) => <option key={x.id || "none"} value={x.id}>{x.name}</option>)}</select></li>
      ))}</ul>}
    </li>
  );
};

export default function BFGamaEditor({ cfg, setCfg, brand }) {
  const gamas = (cfg.gamas || []).filter((g) => g.brand === brand);
  const [nm, setNm] = useState("");
  const setG = (ng) => setCfg({ ...cfg, gamas: cfg.gamas.map((g) => (g.id === ng.id ? ng : g)) });
  const move = (p, gid) => setCfg({ ...cfg, products: cfg.products.map((x) => (x.id === p.id ? { ...x, gama: gid } : x)) });
  const addG = () => {
    const name = nm.trim();
    if (!name) return;
    const id = `${brand}-${name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-")}-${Date.now().toString(36).slice(-3)}`.slice(0, 80);
    setCfg({ ...cfg, gamas: [...(cfg.gamas || []), { id, brand, cat: "Altele", name, desc: "" }] });
    setNm("");
  };
  const delG = (g) => window.confirm(`Ștergi gama ${g.name}? Produsele ei rămân fără gamă.`) && setCfg({ ...cfg, gamas: cfg.gamas.filter((x) => x.id !== g.id), products: cfg.products.map((p) => (p.gama === g.id ? { ...p, gama: "" } : p)) });
  const loose = cfg.products.filter((p) => p.brand === brand && !gamas.some((g) => g.id === p.gama));
  const opts = [{ id: "", name: "— fără gamă —" }, ...gamas];
  return (
    <section className="invite-box" data-testid="bf-gama-editor">
      <h3><Layers size={16} /> Game {cfg.brands.find((b) => b.id === brand)?.name}</h3>
      <p className="st-hint">Așa apar cadranele de game în magazin și în Comanda agent. Corectează numele, categoria, descrierea sau mută produsele, apoi apasă Salvează sus.</p>
      <ul className="bf-ge">
        {gamas.map((g) => <Gama key={g.id} g={g} gamas={opts} prods={cfg.products.filter((p) => p.brand === brand && p.gama === g.id)} setG={setG} move={move} onDel={() => delG(g)} />)}
        {loose.length > 0 && <Gama g={{ id: "", name: "Fără gamă", cat: "Altele", desc: "" }} fixed gamas={opts} prods={loose} move={move} />}
      </ul>
      <div className="bfc-add"><input value={nm} onChange={(e) => setNm(e.target.value)} placeholder="Nume gamă nouă" data-testid="bf-ge-new-name" /><button type="button" className="st-btn st-btn--ghost" onClick={addG} disabled={!nm.trim()} data-testid="bf-ge-new-add"><Plus size={14} /> Adaugă gamă</button></div>
    </section>
  );
}
